import qs from 'qs';
import {
  apiPostTrpayDeposit,
} from './testJsonApi';
// import { errorHandle } from './https';
import * as constType from '../constants/actionsTypes';

// const {
//   CSRFToken,
//   trPayOrderPageData,
// } = window;


const memberMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'MID_SUBMIT_LOGIN_DATA': {
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });
      // 等確認登入需要接啥資料再補完整
      // 登入成功的dispatch
      // store.dispatch({ type: constType.SET_USER_TOKEN, payload: 123 });
      // 登入失敗的dispatch
      store.dispatch({ type: constType.LOGIN_FAIL });

      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: false,
      });
      return next(action);
    }

    // 特力 pay 儲值
    case 'MID_POST_TRPAY_DEPOSIT': {
      const request = {
        card_accountNumber: action.payload.card_accountNumber,
        card_accountNumber2: action.payload.card_accountNumber2,
        card_accountNumber3: action.payload.card_accountNumber3,
        card_accountNumber4: action.payload.card_accountNumber4,
        card_expirationMonth: action.payload.card_expirationMonth,
        card_expirationYear: action.payload.card_expirationYear,
        isChooseRecordCreditCard: action.payload.isChooseRecordCreditCard,
        trpay_paycode: action.payload.trpay_paycode,
        isChooseLazyCheckout: action.payload.isChooseLazyCheckout,
        lazyCheckoutCard_pk: action.payload.lazyCheckoutCard_pk,
        card_cvNumber: action.payload.card_cvNumber,
        amount: action.payload.amount,
        CSRFToken,
      };

      const postRequest = qs.stringify(request);
      store.dispatch({
        type: constType.CHANGE_EFFECT_ISLOADING,
        payload: true,
      });

      apiPostTrpayDeposit('post', postRequest)
        .then((res) => {
          const rtnObj = $.parseJSON(res.data);
          const rtnCode = parseInt(rtnObj.rtnCode);
          let { rtnMsg } = rtnObj;
          const { goUrl } = rtnObj;
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });

          if (rtnCode === 1) {
            window.location.href = goUrl;
          } else if (rtnCode === -2) {
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
            store.dispatch({
              type: constType.UPDATE_TRAYDEPOSIT_API_RESPONSE_MESSAGE,
              payload: rtnMsg,
            });
            store.dispatch({
              type: constType.UPDATE_API_REDIRECT_URL,
              payload: goUrl,
            });
          } else if (rtnCode === 3) {
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
            store.dispatch({
              type: constType.UPDATE_TRAYDEPOSIT_API_RESPONSE_MESSAGE,
              payload: rtnMsg,
            });
            store.dispatch({
              type: constType.UPDATE_API_REDIRECT_URL,
              payload: goUrl,
            });
          } else {
            rtnMsg = rtnMsg.replace(/\n/g, '<br />');
            store.dispatch({
              type: constType.SHOW_EXCEPTION_MODAL,
              payload: true,
            });
            store.dispatch({
              type: constType.UPDATE_TRAYDEPOSIT_API_RESPONSE_MESSAGE,
              payload: rtnMsg,
            });
          }
        })
        .catch(() => {
          // console.log(err);
          store.dispatch({
            type: constType.CHANGE_EFFECT_ISLOADING,
            payload: false,
          });
        });

      return next(action);
    }

    case 'MID_GET_TRPAY_ORDERPAGE_DATA': {
      store.dispatch({
        type: constType.GET_TRPAY_ORDERPAGE_DATA,
        payload: trPayOrderPageData,
      });
      return next(action);
    }
    default:
      return next(action);
  }
};

export default memberMiddleware;
